import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const DrawPrintAnswersCanvas = styled.div`
  border-radius: ${rem(borderRadius8)};
  inset: 0;
  position: absolute;

  // draw canvas does not need to be visible
  canvas {
    visibility: hidden;
  }
`;

export const DrawPrintAnswersCanvasInner = styled.div`
  position: absolute;
  inset: 1px;
  img {
    width: 100%;
  }
`;
